const state = {
  userStatus: "" // auth, notauth => controls component display
}

const getters = {
  getUserStatus: state =>{
    return state.userStatus;
  }
}

const actions = {
  updateUserStatus:({ commit }, status) => {
    commit("setUserStatus", status);
  }
}

const mutations = {
  setUserStatus:(state, status) => {
    state.userStatus = status;
    return state.userStatus;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
